const MECHANIC = "/mechanic";

export const getAllMechanicCollections = `${MECHANIC}/getAllMechanicCollections`;

export const getMechanicWeeklyBonus = `${MECHANIC}/getMechanicWeeklyBonus`;

export const GET_MECHANIC_DETAILS = `${MECHANIC}/getMechanicDetails`;

export const CREATE_MECHANIC_BACK_IN_STOCK = `${MECHANIC}/createMechanicBackInStock/:skuId`;
